import { render, staticRenderFns } from "./StackedBar.vue?vue&type=template&id=189c420b&"
import script from "./StackedBar.vue?vue&type=script&lang=js&"
export * from "./StackedBar.vue?vue&type=script&lang=js&"
import style0 from "./StackedBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports